import React from 'react';

import WidgetInput from './WidgetInput';

import PropsStatic from './interfaces/PropsStaticInterface';

export default class WidgetStatic extends WidgetInput<PropsStatic> {
    trustedHtml() {
        return { __html: this.props.text };
    }

    render() {
        return React.createElement(
            'div',
            {
                className: this.props.class || '',
            },
            <div dangerouslySetInnerHTML={this.trustedHtml()}></div>
        );
    }
}
